import React from 'react';
import Link from 'gatsby-link';

class Service extends React.Component {
  constructor(props) {
    super(props);
    this.handleMouseHover = this.handleMouseHover.bind(this);
    this.state = {
      isHovering: false,
    };
  }
  handleMouseHover() {
    this.setState(this.toggleHoverState);
  }

  toggleHoverState(state) {
    return {
      isHovering: !state.isHovering,
    };
  }
  render() {
    const { icon, iconActive, link, title, text } = this.props;
    return (
      <div
        className="service"
        onMouseEnter={this.handleMouseHover}
        onMouseLeave={this.handleMouseHover}
      >
        <Link to={link}>
          <div className="service__icon">
            {this.state.isHovering
              ? <img src={iconActive} alt="Icon" />
              : <img src={icon} alt="Icon" />}
          </div>
          <h3 className="service__title">{title}</h3>
          <p className="service__text">{text}</p>
          <div className="service__readmore">
            <i className="c-icon c-icon--chevron_right"></i>
            <span>Mehr erfahren</span>
          </div>
        </Link>
      </div>
    );
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/components/service/index.js